export default __webpack_public_path__ + "static/media/OrbitIconWhite.4b6d35ac.svg";